// ACC-linked projects (back/routes/acc.js). The api helpers resolve an error body
// rather than throwing on it, so every call here turns { error } into a throw.
import { get, post, remove } from "api";

const ok = (p) =>
  p.then((r) => {
    if (r && r.error) throw new Error(r.error);
    return r;
  });

export const getAccStatus = () => ok(get(`/acc/status`));
// `connection`: 'new' signs in an additional Autodesk account, an id reconnects that one
export const getAccConnectUrl = (connection) => ok(get(`/acc/connect${connection ? `?connection=${encodeURIComponent(connection)}` : ""}`));
export const disconnectAcc = () => ok(post(`/acc/disconnect`, {}));

// browsing, with one of the company's Autodesk accounts (`connection` = its id; none = its primary)
const withConn = (connection) => (connection ? `?connection=${encodeURIComponent(connection)}` : "");
export const getAccHubs = (connection) => ok(get(`/acc/hubs${withConn(connection)}`));
export const getAccProjects = (hubId, connection) => ok(get(`/acc/hubs/${encodeURIComponent(hubId)}/projects${withConn(connection)}`));
export const getAccTopFolders = (hubId, projectId, connection) =>
  ok(get(`/acc/hubs/${encodeURIComponent(hubId)}/projects/${encodeURIComponent(projectId)}/top-folders${withConn(connection)}`));
export const getAccFolder = (projectId, folderId, connection) =>
  ok(get(`/acc/projects/${encodeURIComponent(projectId)}/folders/${encodeURIComponent(folderId)}/contents${withConn(connection)}`));

export const getAccLinks = (projectIds) => ok(get(`/acc/links?projects=${projectIds.join(",")}`));
export const linkAccFile = (body) => ok(post(`/acc/links`, body));
export const syncAccLink = (projectId) => ok(post(`/acc/links/${projectId}/sync`, {}));
export const unlinkAcc = (projectId) => ok(remove(`/acc/links/${projectId}`, {}));
